import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {pxToRem} from '../../utills/pxToRem'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const Recaptcha = ({onVerify, onExpired, resetToken = 0}) => {
    const recaptchaRef = useRef(null)
    const widgetIdRef = useRef(null)
    const {app: appConfig} = getConfig()
    const siteKey = appConfig?.recaptchaAPI?.recaptchaSiteKey

    const [scriptLoaded, setScriptLoaded] = useState(false)

    // Load the reCAPTCHA script dynamically
    useEffect(() => {
        if (document.getElementById('google-recaptcha-script')) {
            setScriptLoaded(true)
            return
        }

        const callbackName = `onRecaptchaLoadCallback_${Date.now()}`
        window[callbackName] = () => {
            setScriptLoaded(true)
            delete window[callbackName]
        }

        const script = document.createElement('script')
        script.id = 'google-recaptcha-script'
        script.src = `https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=explicit`
        script.async = true
        script.defer = true
        script.onerror = () => {
            console.error('Failed to load reCAPTCHA script')
            delete window[callbackName]
        }

        document.body.appendChild(script)
    }, [])

    // Render reCAPTCHA once
    useEffect(() => {
        if (
            scriptLoaded &&
            window.grecaptcha &&
            recaptchaRef.current &&
            widgetIdRef.current === null
        ) {
            widgetIdRef.current = window.grecaptcha.render(recaptchaRef.current, {
                sitekey: siteKey,
                callback: (token) => {
                    onVerify(token)
                },
                'expired-callback': () => {
                    onExpired?.()
                }
            })
        }
    }, [scriptLoaded, siteKey, onVerify])

    useEffect(() => {
        if (resetToken > 0 && widgetIdRef.current !== null && window.grecaptcha) {
            window.grecaptcha.reset(widgetIdRef.current)
        }
    }, [resetToken])

    return (
        <Box
            sx={{
                marginTop: [
                    `${pxToRem(25)} !important`,
                    `${pxToRem(25)} !important`,
                    `${pxToRem(20)} !important`,
                    `${pxToRem(20)} !important`
                ]
            }}
            ref={recaptchaRef}
        ></Box>
    )
}

Recaptcha.propTypes = {
    onVerify: PropTypes.func.isRequired,
    onExpired: PropTypes.func.isRequired,
    resetToken: PropTypes.number
}

export default Recaptcha
